import { render, staticRenderFns } from "./FooterShout.vue?vue&type=template&id=7786685d&scoped=true&"
import script from "./FooterShout.vue?vue&type=script&lang=js&"
export * from "./FooterShout.vue?vue&type=script&lang=js&"
import style0 from "./FooterShout.vue?vue&type=style&index=0&id=7786685d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7786685d",
  null
  
)

export default component.exports